export default __webpack_public_path__ + "static/media/email.64f13710.png";